import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ServiceProductList.module.scss';
import ProductItem from './ServiceProductListItem';
import { useAppSelector } from '@/store/hooks';
import { getProductBrandAllList } from '@/api/products';

// import icon1 from '@/assets/images/组 2233@2x.png';
// import icon2 from '@/assets/images/组 2234@2x.png';
// import icon3 from '@/assets/images/组 2235@2x.png';
// import icon4 from '@/assets/images/组 2236@2x.png';
// import icon5 from '@/assets/images/组 2237@2x.png';
// import icon6 from '@/assets/images/组 2238@2x.png';
// import icon7 from '@/assets/images/组 2241@2x.png';




interface ServiceProductListProps {
  goodsList: any[];
}


const ServiceProductList: React.FC<ServiceProductListProps> = ({goodsList }) => {


  return (
    <div className={styles['list-box']}>
      <div className={styles['product-box']} >
        {goodsList.map((item) => (
          <ProductItem item={item} key={item?.product_id || item?.id || Math.random()} />
        ))}
      </div>
    </div>
  );
};

export default ServiceProductList; 